module.exports = __webpack_public_path__ + "img/the-big-band-theory.a99f05d6.jpeg";